import React from 'react';
import logo from '../../../../../images/modules/RunUp-logo.svg';
import './index.scss';

export const Footer = () => {
    return (
        <div className='runup-footer'>
            <div className='runup-footer__items'>
                <div className='runup-footer__item'>Shoes & Gear</div>
                <div className='runup-footer__item'>Training</div>
                <div className='runup-footer__item'>Health & Injuries</div>
                <div className='runup-footer__item'>Beginners</div>
                <div className='runup-footer__item'>Must Read</div>
                <div className='runup-footer__item subscribe'>Subscribe</div>
            </div>
            <div className='runup-footer__content'>
                <div className='runup-footer__logo'>
                    <img src={logo} alt='logo' />
                </div>
                <div className='runup-footer__text'>
                    Are you looking to run <br />
                    the best race of your life?
                </div>
            </div>
            <div className='runup-footer__links'>
                <div className='runup-footer__link'>User Agreement</div>
                <div className='runup-footer__link'>Privacy Policy</div>
                <div className='runup-footer__link'>Accessibility Help</div>
                <div className='runup-footer__link'>Masthead</div>
                <div className='runup-footer__link'>Visual Stories</div>
            </div>
        </div>
    );
};
